import Reveal from "./Reveal";
import { principles, stats } from "@/mocks/data";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24" aria-label="关于吃瓜在线">
      <div className="relative overflow-hidden rounded-3xl bg-primary-600 px-4 py-10 md:px-10 md:py-14">
        {/* decorative */}
        <div className="pointer-events-none absolute -right-8 -top-8 float-slow opacity-15">
          <i className="ri-chat-3-fill text-[10rem] text-background-50" />
        </div>
        <div className="pointer-events-none absolute -bottom-14 left-1/3 opacity-10">
          <i className="ri-focus-3-line text-[8rem] text-background-50" />
        </div>

        <div className="relative mx-auto grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-focus-2-line" />
              关于我们
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              吃瓜在线的初衷：
              <br className="hidden sm:block" />
              让每一颗「瓜」都有来处、有真相
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-primary-100">
              「吃瓜在线」是一个专注全网热点与文娱资讯的实时追踪平台。我们不制造话题，也不站队争吵，而是把散落在各平台的
              官方公告、现场动态与多方声音，整理成清晰、可回看的时间线。从重大事件的「刚刚更新」到事件全貌的「深度专题」，
              我们用滚动更新与一手核实，陪你见证每一个热点从发酵到尘埃落定。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-primary-100">
              我们相信，真正的「吃瓜」不是被流量牵着走，而是多一分求证、多一分克制。这也是我们坚持「还原、求证、不站队」
              内容原则的原因。
            </p>
          </div>

          {/* stats */}
          <div className="flex flex-col justify-center">
            <dl className="grid grid-cols-2 gap-3 sm:gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl bg-background-50/10 px-5 py-5 text-center backdrop-blur-sm sm:px-6"
                >
                  <dd className="font-heading text-3xl font-bold text-background-50">{s.value}</dd>
                  <dt className="mt-1 text-xs text-primary-100">{s.label}</dt>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      {/* principles */}
      <div className="mt-10">
        <div className="text-center">
          <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">我们的内容原则</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">
            在热点扑面而来的时代，克制与求证本身就是一种态度。
          </p>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p, i) => (
            <Reveal key={p.title} delay={i * 70}>
              <div className="flex h-full flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-accent-200">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                  <i className={p.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}